export default __webpack_public_path__ + "static/media/EDBscreenshot.fb82c9f2.PNG";